var map = {
	"./1.png": 1325,
	"./2.png": 7350,
	"./3.png": 639,
	"./4.png": 9312,
	"./5.png": 7433,
	"./6.png": 6466,
	"./7.png": 7643,
	"./8.png": 1404,
	"./9.png": 3669,
	"./a.png": 6557,
	"./b.png": 5350,
	"./c.png": 4367,
	"./gg.png": 4396,
	"./img.png": 8001,
	"./tick.png": 7985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7229;